interface WebpackRequire {
  g: { document: Document & { importScripts: unknown } };
  p: string;
}

declare const __webpack_require__: WebpackRequire;

/**
 * Alternative way to determine the current script URL for old browsers.
 *
 * @returns current script URL
 */
const currentScriptURLPolyfill = () => {
  let stack;
  // It will cause an exception to be thrown and capture the stack trace
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    not_valid = invalid_value;
  } catch (e) {
    stack = (e as Record<string, string>).stack;
  }

  if (!stack) return;

  // The stack trace will contain all the path that the error went throught
  // and we can obtain the url of the script that originated the exception (this one)
  // that will be running in the MFE server.
  const at = stack.indexOf(" at ") !== 1 ? " at " : "@";
  while (stack.indexOf(at) !== -1) {
    stack = stack.substring(stack.indexOf(at) + at.length);
  }
  const scriptUrl = stack.substring(
    stack.indexOf("http"),
    stack.indexOf(":", stack.indexOf(".js") + 1)
  );

  return scriptUrl;
};

/**
 * Get the current script URL
 *
 * @returns current script url
 */
const currentScriptURL = () => {
  let scriptUrl;
  const { document } = __webpack_require__.g;
  // If importScripts is available, use it to get the URL from location
  if (document.importScripts) {
    scriptUrl = document.location && `${document.location}`;
  }

  if (!scriptUrl) {
    // Otherwise, check if currentScript is available
    if (document.currentScript) {
      scriptUrl = (document.currentScript as HTMLScriptElement).src;
    }

    // In this case, let's use a 'polyfill' to find the URL (IE specially)
    if (!scriptUrl) {
      scriptUrl = currentScriptURLPolyfill();
    }
  }

  // If not able to determine the script url, abort
  if (!scriptUrl) {
    throw new Error("Automatic publicPath is not supported in this browser");
  }

  // Replace hash path or any other invalid char and return it
  return scriptUrl
    .replace(/#.*$/, "")
    .replace(/\?.*$/, "")
    .replace(/\/[^/]+$/, "/");
};

export default currentScriptURL;
